// Component: Component Scrolling Text
// Description: Creates a smooth infinite right-to-left scrolling loop using GSAP.

function initComponentScrollingText(context = document) {
    const componentScrollingText = context.querySelectorAll('.gb-component-scrolling-text');

    if (componentScrollingText.length === 0) return;

    componentScrollingText.forEach(component => {
        componentScrollingTextInit(component);
    });
}

// Run on frontend
document.addEventListener('DOMContentLoaded', () => {
    initComponentScrollingText();

    // Re-run on resize (debounced)
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            initComponentScrollingText();
        }, 150);
    });
});

function componentScrollingTextInit(component) {
   const componentScrollingTextWrapper = component.querySelector('.gb-component-scrolling-text__wrapper');

   if (componentScrollingTextWrapper == null) return;

    // Clone content to ensure seamless looping.
    if (!componentScrollingTextWrapper.dataset.duplicated) {
        componentScrollingTextWrapper.innerHTML += componentScrollingTextWrapper.innerHTML;
        componentScrollingTextWrapper.dataset.duplicated = true;
    }

    // Kill previous animation if re-running (e.g., on resize).
    if (componentScrollingTextWrapper._gsapScrollTween) {
        componentScrollingTextWrapper._gsapScrollTween.kill();
    }

    // Measure full width of content.
    const width = componentScrollingTextWrapper.scrollWidth / 2;

    // Set scroll speed in px/sec.
    const scrollSpeed = 70; // px per second.

    // Calculate duration dynamically.
    const duration = width / scrollSpeed;

    // Create GSAP loop
    const tween = gsap.fromTo(
        componentScrollingTextWrapper,
        { x: 0 },
        {
            x: -width,
            duration: duration,
            ease: "none",
            repeat: -1,
        }
    );

    componentScrollingTextWrapper._gsapScrollTween = tween;

    // Optional: Pause on hover.
    component.addEventListener('mouseenter', () => tween.pause());
    component.addEventListener('mouseleave', () => tween.play());
}